var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { InfoModalComponent } from "../../views/modal/info_modal.component";
import { AlertComponent } from "../../views/modal/alert.component";
import { ModalService } from "../../views/modal/base_modal.component";
import { TranslateService } from "../../translate/translate.service";
import { FilterFormService } from "../../views/filter_form/filter_form.service";
import { HelperService } from "../../lib/helper.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AccessorService } from "./accessor.service";
import { getUrlParams } from "../../lib/lib";
import merge from "lodash-es/merge";
var AccessorPersonalStatsModalComponent = /** @class */ (function (_super) {
    __extends(AccessorPersonalStatsModalComponent, _super);
    function AccessorPersonalStatsModalComponent(activeModal, helper, translate, modalService, filter, service) {
        var _this = _super.call(this, activeModal) || this;
        _this.activeModal = activeModal;
        _this.helper = helper;
        _this.translate = translate;
        _this.modalService = modalService;
        _this.filter = filter;
        _this.service = service;
        return _this;
    }
    AccessorPersonalStatsModalComponent.prototype.ok = function () {
        this.close();
    };
    AccessorPersonalStatsModalComponent.prototype.download = function () {
        var params = getUrlParams(merge(this.filter.filterParams, {
            accessorEmail: this.email,
            start: this.filter.filterParams.accessorDateFilter.start,
            end: this.filter.filterParams.accessorDateFilter.end
        }));
        window.location.href = this.service.dp.baseRoute + "/accessor2/stats_download?" + params;
        this.modalService.open(AlertComponent, {
            title: 'INFO',
            message: this.translate.__A('common.download file')
        });
    };
    return AccessorPersonalStatsModalComponent;
}(InfoModalComponent));
export { AccessorPersonalStatsModalComponent };
